// @flow

import {cookie} from './cookie-policy-checker';
import getCookieParams from './get-cookieparams';

const cookiesName = {
  locale: 'pa-locale',
  token: 'pa-v4-token',
  merchantID: 'pa-merchant-id',
  originalUrl: 'pa-original-url',
  serviceParams: 'service-params',
  visit: 'pa_visit',
  firstVisit: 'first_visit',
  serverDataFetchingDisabled: '__server-data-fetching-disabled',
  integrationType: 'integration-type',
  hardCopyLocked: 'pa-hard-copy-locked',
  utmCampaign: 'utm_campaign',
  consent_id: 'consent_id',
  postIntegrationSurvey: 'post-integration-survey',
  postIntegrationSurveyDisabled: 'post-integration-survey-disabled',
  postIntegrationSurveyProduct: 'post-integration-survey-product',
  quarterly_survey: 'quarterly_survey',
  endToEndAuthToken: 'end-to-end-auth-token',
  support_survey: 'support_survey',
  sidebar_funding: 'sidebar-funding'
};

const YEAR = 365;

export const setVisitCookies = () => {
  const hostname = window.location.hostname;

  if (!cookie.get(cookiesName.visit)) {
    cookie.set(cookiesName.visit, 1, {
      ...getCookieParams(hostname),
      expires: YEAR
    });
  }

  if (!cookie.get(cookiesName.firstVisit)) {
    cookie.set(cookiesName.firstVisit, 'publisher_account', {
      ...getCookieParams(hostname),
      expires: YEAR
    });
  }
};

export default cookiesName;
